import React from "react";
import { LeadTable } from "./overview/LeadTable";
import { OverviewContainer } from "../../common/OverviewContainer";

export function LeadOverview() {
  return (
    <OverviewContainer title={null}>
      <LeadTable />
    </OverviewContainer>
  );
}
